module.exports = __webpack_public_path__ + "static/media/01.Ganesha Pooja-ink.44abc6cf.jpeg";